import React, { createContext, useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";
import "./App.css";
import particlesOptions from "./particles.json";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import { nanoid } from "nanoid";
import Footer from "./components/Footer";

export const ExpertiseContext = createContext(null);
export const SolutionsContext = createContext(null);
export const ClientsContext = createContext(null);
export const PartnersContext = createContext(null);
export const TeamsContext = createContext(null);
export const MenuContext = createContext(null);

function App() {
  const [init, setInit] = useState(false);
  const [isMenuClicked, setIsMenuClicked] = useState(false);

  const expertiseList = [
    {
      id: nanoid(),
      title: "Web Development",
      img: "serviceImg/webDevelopment.png",
      description1: [
        "Targeted Solutions",
        "Responsive Design",
        "Fast Load Times",
        "Clear Communication",
        "Maintenance and Support",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "Web Designing",
      img: "serviceImg/wedDesign.png",
      description1: [
        "Crafting Stunning Visuals",
        "User-Centric Design",
        "Responsive Design Mastery",
        "SEO Optimized Designs",
        "Collaboration and Innovation",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "UI/UX Design",
      img: "serviceImg/uiUx.png",
      description1: [
        "Visually Stunning Interfaces",
        "Data-Driven Design",
        "Empathy-Driven Design",
        "Intuitive Interactions",
        "Accessibility Focus",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "App Development",
      img: "serviceImg/appDevelopment.png",
      description1: [
        "Cross-Platform Excellence",
        "Performance Optimization",
        "Robust App Architecture",
        "User-Centric Development",
        "Security and Privacy",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "Cloud Services",
      img: "serviceImg/cloud.png",
      description1: [
        "Cloud Architecture and Design",
        "Infrastructure as Code (IaC)",
        "Cloud Security",
        "Cost Optimization",
        "DevOps and Automation",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "Content Management",
      img: "serviceImg/content.png",
      description1: [
        "CMS Proficiency",
        "Content Strategy",
        "SEO Optimization",
        "Content Creation and Curation",
        "Workflow Optimization",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "Digital Marketing",
      img: "serviceImg/digitalMarketing.png",
      description1: [
        "Data-Driven Strategies",
        "Multi-Channel Marketing",
        "Brand Building",
        "Lead Generation and Conversion",
        "Performance Measurement",
      ],
      description2: "",
    },
    {
      id: nanoid(),
      title: "Social Media Marketing",
      img: "serviceImg/socailMedia.png",
      description1: [
        "Strategic Social Media Planning",
        "Engaging Content Creation",
        "Community Building and Management",
        "Data-Driven Optimization",
        "Paid Social Advertising",
      ],
      description2: "",
    },
  ];
  const solutionsList = [
    {
      id: nanoid(),
      title: "MERN Stack Development",
      titleQuote: "We prioritise it for...",
      img: "",
      cardDetails: [
        {
          id: nanoid(),
          title: "JS everywhere",
          description:
            " MERN is a full-stack JavaScript solution, meaning you can use JavaScript for both front-end (React) and back-end (Node.js) development.",
        },
        {
          id: nanoid(),
          title: "Rapid",
          description:
            "React's virtual DOM and JSX syntax allow for faster UI development, while Node.js' event-driven architecture make it easy to find and integrate pre-built modules.",
        },
        {
          id: nanoid(),
          title: "Agile",
          description:
            "The MERN stack is known for its agility. We can quickly prototype, iterate, and deploy new features. This is crucial in today's fast-paced market where businesses need to be adaptable.",
        },
        {
          id: nanoid(),
          title: "Scalable",
          description:
            "MERN applications can be easily scaled. MongoDB's flexible schema and cloud-based deployment options make it easy to handle surges in traffic.",
        },
        {
          id: nanoid(),
          title: "SEO Friendly",
          description:
            "NextJS allows for server-side rendering (SSR) which improves search engine crawlability and initial page load speed, this can be a major benefit for businesses.",
        },
        {
          id: nanoid(),
          title: "Real-Time",
          description:
            "By utilizing WebSockets, MERN applications can establish two-way communication channels. This allows for features like live chat, collaborative editing, and real-time data updates.",
        },
        {
          id: nanoid(),
          title: "Cross-Platform",
          description:
            "React, the front-end framework of MERN, has a close cousin - React Native. This translates to faster mobile development times and potentially lower costs for businesses.",
        },
      ],
    },
    {
      id: nanoid(),
      title: "eCommerce Store",
      titleQuote: "where creativity meets commerce...",
      img: "",
      cardDetails: [
        {
          id: nanoid(),
          title: "Appealing Designs",
          description:
            " MERN is a full-stack JavaScript solution, meaning you can use JavaScript for both front-end (React) and back-end (Node.js) development.",
        },
        {
          id: nanoid(),
          title: "CMS",
          description:
            "React's virtual DOM and JSX syntax allow for faster UI development, while Node.js' event-driven architecture make it easy to find and integrate pre-built modules.",
        },
        {
          id: nanoid(),
          title: "Secure Payment Gateways",
          description:
            "The MERN stack is known for its agility. We can quickly prototype, iterate, and deploy new features. This is crucial in today's fast-paced market where businesses need to be adaptable.",
        },
        {
          id: nanoid(),
          title: "Advanced Shopping Cart",
          description:
            "MERN applications can be easily scaled. MongoDB's flexible schema and cloud-based deployment options make it easy to handle surges in traffic.",
        },
        {
          id: nanoid(),
          title: "Upselling & Cross-Selling Feature",
          description:
            "By utilizing WebSockets, MERN applications can establish two-way communication channels. This allows for features like live chat, collaborative editing, and real-time data updates.",
        },
        {
          id: nanoid(),
          title: "Promotions Management",
          description:
            "React, the front-end framework of MERN, has a close cousin - React Native. This translates to faster mobile development times and potentially lower costs for businesses.",
        },
        {
          id: nanoid(),
          title: "Third Party Integration",
          description:
            "React, the front-end framework of MERN, has a close cousin - React Native. This translates to faster mobile development times and potentially lower costs for businesses.",
        },
        {
          id: nanoid(),
          title: "Scalable Solutions",
          description:
            "React, the front-end framework of MERN, has a close cousin - React Native. This translates to faster mobile development times and potentially lower costs for businesses.",
        },
      ],
    },
    {
      id: nanoid(),
      title: "Python Development",
      titleQuote: "We value it for...",
      img: "",
      cardDetails: [
        {
          id: nanoid(),
          title: "Versatile",
          description:
            " MERN is a full-stack JavaScript solution, meaning you can use JavaScript for both front-end (React) and back-end (Node.js) development.",
        },
        {
          id: nanoid(),
          title: "Widespread",
          description:
            "React's virtual DOM and JSX syntax allow for faster UI development, while Node.js' event-driven architecture make it easy to find and integrate pre-built modules.",
        },
        {
          id: nanoid(),
          title: "Loved by Innovator",
          description:
            "The MERN stack is known for its agility. We can quickly prototype, iterate, and deploy new features. This is crucial in today's fast-paced market where businesses need to be adaptable.",
        },
        {
          id: nanoid(),
          title: "Challanges",
          description:
            "MERN applications can be easily scaled. MongoDB's flexible schema and cloud-based deployment options make it easy to handle surges in traffic.",
        },
        {
          id: nanoid(),
          title: "Future Proof",
          description:
            "By utilizing WebSockets, MERN applications can establish two-way communication channels. This allows for features like live chat, collaborative editing, and real-time data updates.",
        },
        {
          id: nanoid(),
          title: "Cross-Platform",
          description:
            "React, the front-end framework of MERN, has a close cousin - React Native. This translates to faster mobile development times and potentially lower costs for businesses.",
        },
        {
          id: nanoid(),
          title: "Portability",
          description:
            "React, the front-end framework of MERN, has a close cousin - React Native. This translates to faster mobile development times and potentially lower costs for businesses.",
        },
      ],
    },
    {
      id: nanoid(),
      title: "PHP Development",
      titleQuote: "We love PHP because it is...",
      img: "",
      cardDetails: [
        {
          id: nanoid(),
          title: "Easy and Simple to Learn",
          description:
            "Along with PHP syntax being logical and well-organized, the command functions are easy to understand, as they tell the developer what function they perform.",
        },
        {
          id: nanoid(),
          title: "Extremely Flexible",
          description:
            "The ability to make changes even after starting the project saves valuable time. A developer does not have to write fresh codes or command functions, as changes to the existing codes and functions can be done and used.",
        },
        {
          id: nanoid(),
          title: "Easy Integration",
          description:
            "PHP is compatible with a large majority of operating systems. As it can be integrated without effort with other technologies, such as Java, existing software does not require re-development. This saves time and money.",
        },
        {
          id: nanoid(),
          title: "Efficient Performance",
          description:
            "It is scalable when used for writing codes or creating a large number of applications. It is the programming language of choice when a website has several web pages.",
        },
        {
          id: nanoid(),
          title: "Cost Efficient",
          description:
            "PHP is an open-source web language, hence is completely free. There is no expense involved in purchasing expensive licenses or software. It can work efficiently with different databases, such as MySQL, Apache, and PostgreSQL",
        },
        {
          id: nanoid(),
          title: "Challenges",
          description:
            "While PHP may be a powerful tool supported by an outsized community and plentiful reference documentation, there are easier programming languages for web apps.",
        },
      ],
    },
  ];
  const ClientsList = [
    {
      id: nanoid(),
      company: "Alphacomm + The IT Solutions:",
      task: "Developing a new 130R platform.",
      taskDetail:
        "To design a platform that will allow providers to securely and easily link their own warehouses and provide secure and simple integrations with the individual proprietary products and other standard products available in the market.",
      solutionDetail:
        "TIS is developing a new reload platform integrated with the PimCore e-commerce platform, which enables retailers to realize the ideal customer journey based on data and insight into the behavior of its customers measured by the platform and processed and shared via, for example, a tool such as Power BI.",
      aboutClient:
        "Alphacomm B.V. (AC) is the authority in the online digital goods market. The company founded and still based in Rotterdam has the ambition to become a global player with 'the dominant revenue boosting platform'. With a clear vision on the current and future market and with a solid technological footprint, AC helps its customers grow their turnover and ensures that the risk of fraud and default is minimal. In order to make the right technological choices to realize this ambition, AC was looking for a new partner in Development, Operations and Cloud engineering and ended up at The IT Solutions (TIS).",
      clientLogo: "",
      quote:
        "TIS is developing a new reload platform integrated with the PimCore e-commerce platform, which enables retailers to realize the ideal customer journey based on data and insight into the behavior of its customers measured by the platform and processed and shared via, for example, a tool such as Power BI.",
      clientName: "Mayank Joshi",
    },
    {
      id: nanoid(),
      company: "Gulf Gas & Power + The IT Solutions:",
      task: "Developing employee, sales, and customer portals.",
      taskDetail:
        "GGP uses a SaaS solution for the energy domain to support back-office processes, such as billing and meter reading processing. They hired a third party for acquisition and contracts, who developed various platforms for this. Robin van Klaveren, co-founder at GGP: “That was custom work, but lacked important functionality. The link with our backend system was not properly executed and maintenance proved to be difficult. Moreover, the platform was not very scalable.” GGP was, therefore, looking for a party that could not only solve these problems but could also think about the future. In November 2019, Van Klaveren met old acquaintance Quincy Verkolf, CEO at The IT Solutions (TIS).",
      solutionDetail:
        "TIS subsequently partly redeveloped the application, because the data model and the associated architecture turned out not to be scalable. TIS built applications for the employee portal, sales portal, and customer portal. In addition, the company provides maintenance for both individual applications and the landscape in general. TIS developed new features and finally, TIS also manages the supplier of the back-office applications. Van Klaveren: 'In the seven months since the kickoff, TIS has created tremendous value with new features and bug fixes.'Because GGP does not employ its own IT staff, TIS is fully responsible for the development and maintenance of the applications. Until now, this has been done, out of necessity, completely remotely. The lines are short though; when contact is needed, Van Klaveren and his colleagues can quickly reach the right TIS people. 'We have to because we have been in the clean-up and furnishing phase so far, but if we take the next step soon, we will be brainstorming.'",
      aboutClient:
        "As an energy supplier, Gulf Gas + Power (GGP) focuses on the B2B segment. GGP is a no-nonsense supplier; after working for years with other parties in the energy sector, the three founders decided that things had to be done differently. At GGP, energy contracts can be concluded fairly, easily, and without fuss. To serve its new and existing 20,000 customers, the company GGP employs 30 people; all experts in the field of energy, but not of IT. GGP, therefore, decided to outsource this completely.",
      clientLogo: "",
      quote:
        "We only do what we can distinguish ourselves, we outsource everything else. We also dare to hand it over to The IT Solutions because we have built up a good mutual relationship very quickly. We know what we have together and are the same. We, therefore, have every confidence in the future - even if the IT landscape becomes more complicated in the future.",
      clientName: "Mayank Joshi",
    },
    {
      id: nanoid(),
      company: "Waive + The IT Solutions:",
      task: "Digital transformation of hotel booking.",
      taskDetail:
        "To design a web application using which guests can easily use the facilities and offers of a hotel. For example, reservations, room service or the rental of an E-bike. All data is collected, analyzed and used to obtain more return from the existing hotel services.",
      solutionDetail:
        "In cooperation with TIS, Waive set the MVP's objectives and preconditions tightly before converting them into concrete development steps. The MVP was actually built based on short sprints according to the scrum methodology. Every Monday, there was a team-wide Skype session, evaluating last week's sprint and setting goals for the week ahead. 'Working in weekly sprints with TIS ensures that you see clear progress and that we can adjust quickly if necessary.' After the planned 5 weeks, the MVP was live at some Waive customers. You can clearly see that the expertise of the TIS team is an enormous added value for early stage start-ups. First, the transformation of Waive's initial plans into a concrete development plan saves a lot in time-to-market and budget. Secondly, TIS ensured the quality and robustness of developments by implementing minor quality improvements on its own initiative. 'Especially in the MVP phase, it is important for startups that the development partner can guarantee quality and prevent downtime with customers.'",
      aboutClient:
        "Waive helps hoteliers to digitize service. The goal is simple: Improving the guest experience while increasing the hotel's revenue. Main focus of Waive is the support within this process, in order to contribute to the digital transition of the hotel owner. Waive co-created this SaaS solution together with The IT Solutions (TIS). In the search for a partner who could help build an MVP, Waive entered into dialogue with The IT Solutions (TIS) on the advice of one of the investors. “When starting a company, you have to deal specifically with the development budget. There is not much room to experiment with different partners,” says Nout Knabben, founder and CEO of Waive. 'TIS turned out to be the right partner for fast and targeted development.'",
      quote:
        "Our customers are very satisfied with the current app and if our customers are satisfied, so are we. To boost that satisfaction, we are looking for continuous improvements in our services. We see TIS as a strong partner for growth because they pursue the same goals as we do.",
      clientName: "Mayank Joshi",
    },
  ];
  const PartnersList = [
    {
      id: nanoid(),
      name: "AWS",
      img: "partners/aws.png",
    },
    {
      id: nanoid(),
      name: "Azure",
      img: "partners/Azure.png",
    },
    {
      id: nanoid(),
      name: "Azure",
      img: "partners/BriefCam.png",
    },
    {
      id: nanoid(),
      name: "Azure",
      img: "partners/aruba.jpg",
    },
    {
      id: nanoid(),
      name: "Brocade",
      img: "partners/brocade.jpg",
    },
    {
      id: nanoid(),
      name: "Cyrusone",
      img: "partners/cyrusone.jpg",
    },
    {
      id: nanoid(),
      name: "Dell",
      img: "partners/dell.png",
    },
    {
      id: nanoid(),
      name: "F5",
      img: "partners/f5.jpg",
    },
    {
      id: nanoid(),
      name: "Hewlett",
      img: "partners/hewlett.png",
    },
    {
      id: nanoid(),
      name: "HoBOC",
      img: "partners/HoBOC.jpg",
    },
    {
      id: nanoid(),
      name: "Liquidware",
      img: "partners/liquidware.png",
    },
    {
      id: nanoid(),
      name: "Microsoft",
      img: "partners/Microsoft.png",
    },
    {
      id: nanoid(),
      name: "Milestone",
      img: "partners/milestone.png",
    },
    {
      id: nanoid(),
      name: "Nutanix",
      img: "partners/nutanix.jpg",
    },
    {
      id: nanoid(),
      name: "Palo",
      img: "partners/Palo.png",
    },
    {
      id: nanoid(),
      name: "Panasas",
      img: "partners/Panasas.png",
    },
    {
      id: nanoid(),
      name: "Phoenix Nap",
      img: "partners/PhoenixNap.jpg",
    },
    {
      id: nanoid(),
      name: "Qumulo",
      img: "partners/qumulo.jpg",
    },
    {
      id: nanoid(),
      name: "Scality",
      img: "partners/scality.jpg",
    },
    {
      id: nanoid(),
      name: "Service Now",
      img: "partners/ServiceNow.png",
    },
    {
      id: nanoid(),
      name: "Systems",
      img: "partners/Systems.png",
    },
    {
      id: nanoid(),
      name: "Veeam",
      img: "partners/Veeam.png",
    },
  ];
  const TeamsList = [
    {
      id: nanoid(),
      img: "Team/scrum.png",
      name: "Siddharth",
      title: "Agile Coach",
    },
    {
      id: nanoid(),
      img: "Team/scrum.png",
      name: "Sujan Bista",
      title: "Web Designer",
    },
    {
      id: nanoid(),
      img: "Team/scrum.png",
      name: "Chandra Shekhar Azad",
      title: "Back-end Developer",
    },
    {
      id: nanoid(),
      img: "Team/scrum.png",
      name: "Tribhuwan Singh",
      title: "Back-end Developer",
    },
  ];
  useEffect(() => {
    if (init) {
      return;
    }

    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => {
      setInit(true);
    });

    document.addEventListener('contextmenu', event => event.preventDefault()); // For disabling right click menu or Context menu of a web browser.

  }, [init]);

  return (
    <MenuContext.Provider value={[isMenuClicked, setIsMenuClicked]}>
      <ExpertiseContext.Provider value={expertiseList}>
        <SolutionsContext.Provider value={solutionsList}>
          <ClientsContext.Provider value={ClientsList}>
            <PartnersContext.Provider value={PartnersList}>
              <TeamsContext.Provider value={TeamsList}>
                <div className="App w-screen">
                  {init && <Particles options={particlesOptions} />}
                  <div className="">
                    <Header />
                    <div className="pt-36 text-white">
                      <Outlet />
                    </div>
                    <Footer />
                  </div>
                </div>
              </TeamsContext.Provider>
            </PartnersContext.Provider>
          </ClientsContext.Provider>
        </SolutionsContext.Provider>
      </ExpertiseContext.Provider>
    </MenuContext.Provider>
  );
}

export default App;
